import { IGiangVien } from "../../../model/respone/category/IGiangVien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eGiangVienActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IGiangVien[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IGiangVien | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IGiangVien,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eGiangVienActionIds = generateActionTypeIds(
  eGiangVienActionsObj,
  "GIANG_VIEN"
);
export type IGiangVienActionTypes = IGenericActionType<
  typeof eGiangVienActionsObj,
  "GIANG_VIEN"
>;
